import { useContext } from "react";
import TimezoneContext from "../TimeZoneContext";

/**
 * @description Returns the timezone context
 */
export const useTimezoneContext = () => {
  return useContext(TimezoneContext);
};
